import '../styles/Empresas.css';
import Navbar from '../componentes/Navbar';
import Ofertas from '../componentes/Ofertas';
function Postulaciones() {

  return (
    <div className='empresas'>
      <Navbar />
      <Ofertas />
    </div>
  );
}

export default Postulaciones;